/**
 * Luxury header search only — login clicks handled by fineri-login-flow.js.
 */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;
  if (document.documentElement.getAttribute('data-fineri-header-icons-bound') === 'true') return;
  document.documentElement.setAttribute('data-fineri-header-icons-bound', 'true');

  function searchInline(wrap) {
    return wrap ? wrap.querySelector('[data-fineri-search-inline]') : null;
  }

  function isSearchOpen(wrap) {
    var inline = searchInline(wrap);
    return !!(inline && inline.classList.contains('is-open'));
  }

  function closeSearch(wrap) {
    if (!wrap) return;
    var inline = searchInline(wrap);
    if (!inline || !inline.classList.contains('is-open')) return;
    inline.classList.remove('is-open');
    var panel = wrap.querySelector('[data-fineri-search-panel]');
    var toggle = wrap.querySelector('[data-fineri-search-toggle]');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function openSearch(wrap) {
    if (!wrap) return;
    var inline = searchInline(wrap);
    var panel = wrap.querySelector('[data-fineri-search-panel]');
    var toggle = wrap.querySelector('[data-fineri-search-toggle]');
    var input = panel ? panel.querySelector('[data-fineri-search-panel-input]') : null;
    if (!inline || !toggle) return;
    inline.classList.add('is-open');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (input && typeof input.focus === 'function') {
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  }

  document.addEventListener(
    'click',
    function (ev) {
      var toggle =
        ev.target && ev.target.closest ? ev.target.closest('[data-fineri-search-toggle]') : null;
      if (toggle) {
        var wrap = toggle.closest('[data-fineri-header]');
        if (!wrap || !searchInline(wrap)) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (isSearchOpen(wrap)) closeSearch(wrap);
        else openSearch(wrap);
        return;
      }

      var closeBtn =
        ev.target && ev.target.closest ? ev.target.closest('[data-fineri-search-close]') : null;
      if (closeBtn) {
        var closeWrap = closeBtn.closest('[data-fineri-header]');
        if (closeWrap) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          closeSearch(closeWrap);
        }
        return;
      }

      document.querySelectorAll('[data-fineri-header]').forEach(function (wrap) {
        if (!isSearchOpen(wrap)) return;
        var inline = searchInline(wrap);
        if (inline && inline.contains(ev.target)) return;
        closeSearch(wrap);
      });
    },
    true
  );

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    document.querySelectorAll('[data-fineri-header]').forEach(closeSearch);
  });
})();
